import { useState, useEffect, useCallback } from 'react';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const TimePicker = ({ value = '12:00', onChange, className = '' }) => {
  const [timeHour, setTimeHour] = useState('12');
  const [timeMinute, setTimeMinute] = useState('00');
  const [timeAmPm, setTimeAmPm] = useState('PM');

  // Parse initial value only when value prop changes
  useEffect(() => {
    if (value) {
      const [h, m] = value.split(':');
      let hour24 = parseInt(h);
      const minute = m || '00';
      
      if (hour24 >= 12) {
        setTimeAmPm('PM');
        setTimeHour(hour24 === 12 ? '12' : (hour24 - 12).toString());
      } else {
        setTimeAmPm('AM');
        setTimeHour(hour24 === 0 ? '12' : hour24.toString());
      }
      setTimeMinute(minute);
    }
  }, [value]);

  // Convert to 24-hour format and notify parent
  const notifyChange = useCallback((hour, minute, ampm) => {
    let hour24 = parseInt(hour);
    if (ampm === 'PM' && hour24 !== 12) {
      hour24 += 12;
    } else if (ampm === 'AM' && hour24 === 12) {
      hour24 = 0;
    }
    const time24 = `${hour24.toString().padStart(2, '0')}:${minute}`;
    onChange && onChange(time24);
  }, [onChange]);

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <Input
        type="number"
        min="1"
        max="12"
        value={timeHour}
        onChange={(e) => {
          let val = parseInt(e.target.value) || 1;
          if (val > 12) val = 12;
          if (val < 1) val = 1;
          const newHour = val.toString();
          setTimeHour(newHour);
          notifyChange(newHour, timeMinute, timeAmPm);
        }}
        className="w-14 text-center"
      />
      <span className="text-muted-foreground">:</span>
      <Input
        type="number"
        min="0"
        max="59"
        value={timeMinute}
        onChange={(e) => {
          let val = e.target.value.padStart(2, '0');
          if (parseInt(val) > 59) val = '59';
          setTimeMinute(val);
          notifyChange(timeHour, val, timeAmPm);
        }}
        className="w-14 text-center"
      />
      <Select 
        value={timeAmPm} 
        onValueChange={(newAmPm) => {
          setTimeAmPm(newAmPm);
          notifyChange(timeHour, timeMinute, newAmPm);
        }}
      >
        <SelectTrigger className="w-16">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="AM">AM</SelectItem>
          <SelectItem value="PM">PM</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
